"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Triangle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Triangle_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.557 9.986 10.52 4.535c-.565-1.016-.957-1.717-1.294-2.212-.342-.501-.536-.645-.645-.696-.37-.17-.792-.17-1.162 0-.109.05-.303.195-.645.696-.337.495-.729 1.196-1.294 2.212L2.443 9.986c-.558 1.003-.943 1.695-1.184 2.237-.242.547-.27.797-.256.935.046.432.267.817.598 1.063.097.072.309.17.888.224.575.054 1.348.055 2.474.055h6.074c1.126 0 1.9-.001 2.474-.055.58-.055.791-.152.888-.224a1.52 1.52 0 0 0 .598-1.063c.014-.138-.014-.388-.256-.934-.242-.543-.626-1.235-1.184-2.238ZM4.963 15.5h6.074c2.211 0 3.317 0 3.959-.477a2.52 2.52 0 0 0 .995-1.76c.086-.808-.463-1.793-1.56-3.763l-3.037-5.452C10.282 2.051 9.726 1.053 8.998.718a2.387 2.387 0 0 0-1.996 0c-.728.335-1.284 1.333-2.396 3.33L1.57 9.5C.472 11.47-.077 12.455.009 13.263a2.52 2.52 0 0 0 .995 1.76c.642.477 1.748.477 3.96.477Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Triangle_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Triangle;
exports["default"] = _default;